<template>
  <div>
    <el-col class="search-show-item" v-for="(item,index) in queryList" :key="index">
      <el-col class="show-item-info">
        <el-col :span="7" class="item-info-img">
          <!-- <img :src="item.imageUrl || img" alt="" class="cursor" @click="getHotelDetail(item)"> -->
          <el-image
            :src="item.imageUrl"
            fit="cover"
            class="item-info-img"
            @click="getHotelDetail(item)"
          >
            <div slot="error" class="image-slot">
              <img :src="img" alt />
            </div>
          </el-image>
        </el-col>
        <el-col :span="13" class="item-info-text">
          <p>
            <span class="cursor" @click="getHotelDetail(item)">{{item.hotelNameCn}}</span>
          </p>
          <p class="flex-center-start">
            <sub class="font-15 city-py">({{item.hotelNameEn}})</sub>
            <span
              class="item-info-ico font-13"
              :class="{'info-ico-a':item.star==20,
                      'info-ico-b':item.star==25||item.star==30,
                      'info-ico-d':item.star==35||item.star==40,
                      'info-ico-f':item.star==45||item.star==50||item.star==55,
                      }"
            >
              {{
              item.star==20 || item.star==25?'经济型':
              item.star==30 || item.star==35?'舒适型':
              item.star==40 || item.star==45?'高档型':
              item.star==50 || item.star==55?'豪华型':
              ''}}
            </span>
          </p>
          <p class="font-15">【{{item.bizName}}】{{item.addressCn}}</p>
          <p>{{item.phone}}</p>
          <p class="info-font-icon" v-if="item.facilities">
            <i
              class="iconfont"
              :class="'icon'+zitem"
              v-for="(zitem,zindex) in item.facilities.split('|')"
              :key="zindex"
            ></i>
          </p>
        </el-col>
        <el-col :span="3" class="hotel-price-box flex-center">
          <div>
            <p v-loading="!item.cose">
              <span class="font-15" v-if="item.cose != '暂无'">¥</span>
              {{item.cose}}
              <span class="font-10" v-if="item.cose != '暂无'">起</span>
            </p>
            <el-button type="primary" size="small" @click="getHotelDetail(item)">查看详情</el-button>
          </div>
        </el-col>
      </el-col>
      <!-- <el-col v-if="item.weekPrice?item.weekPrice.length>0:false">
                    <kalendar
                    :index="index"
                    @clickDate="clickDate"
                    @clickNowDate="clickNowDate"
                    :weekPrice="item.weekPrice"
                    :formData="formData"
                    :dayColor="dayColor[index] || 0"
                    />
      </el-col>-->
      <!-- <el-col v-if="item.hotelList">
                    <home-list v-for="(item,sindex) in item.hotelList"
                    :key="sindex"
                    :hotelId="queryList[index].hotelId"
                    :queryList="queryList[index]"
                    :index="sindex"
                    :list="item"
                    :calendarNow="calendarNow[index]"
                    :formData="formData"
                    ></home-list>
                    <el-col class="flex-center font-13  border-top home-more-btn" v-if="allShowList[index]" v-show="item.hotelListAll.length>hotelListNum">
                       <div class="cursor" @click="allShowHotelList(index)">{{allShowList[index].text}} <i :class="allShowList[index].ico"></i></div>
                    </el-col>
      </el-col>-->
    </el-col>
  </div>
</template>
<script>
import kalendar from "./search-kalendar";
import HomeList from "./homeList";
import {
  getHotelNightlyRates,
  queryRoomRatePlan,
  queryRoomPackageList,
  queryRoomList,
  getHotelMinPriceByHotelId
} from "@/lib/data-service/hotel";
import { STATUS } from "@/lib/deprecated/utils/status";
import { setSession } from "@/lib/deprecated/utils/caching";
const SUCCESS_CODE = STATUS.success;
export default {
  data() {
    return {
      hotelFormDate: {
        currentPage: 1,
        pageSize: 6
      }, //酒店日历金额
      weekPrice: [], //日历金额
      hotelList: [], //原房间列表
      hotelListNum: 5, //房型显示个数
      allShowList: [],
      dayColor: [], //日期显示active
      img:
        "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/2020/07/06/default-hotel.jpg?x-oss-process=style/yinzhilv-default",
      selectDate: [
        { index: 0, date: this.$moment().format("YYYY-MM-DD") },
        { index: 0, date: this.$moment().format("YYYY-MM-DD") },
        { index: 0, date: this.$moment().format("YYYY-MM-DD") }
      ],
      homePackage: {
        currentPage: 1,
        pageSize: 5
      }, //房型套餐
      calendarNow: [] //日历选择
    };
  },
  methods: {
    //日期
    weekInfo() {
      this.hotelFormDate.checkInDate = this.$moment(
        this.formData.checkInTime
      ).format("YYYY-MM-DD");
      // console.log(this.hotelFormDate)
      //                 let nowTime = this.$moment().format('YYYY-MM-DD')
      //                 let dayTime = this.$moment(this.formData.checkInTime).format('YYYY-MM-DD')
      //                 let now = new Date(nowTime).getTime()
      //   　　          let days = new Date(dayTime).getTime() - now
      //                 this.dayColor = parseInt(days / (1000 * 60 * 60 * 24))
    },

    //房型列表
    getHome(date, id, list) {
      let data = {
        currentSelectedDate: date,
        hotelId: id,
        currentPage: 1,
        pageSize: 100
      };
      let hotelText = {
        text: "查看更多房型",
        statu: false,
        ico: "el-icon-arrow-down"
      };
      queryRoomList(data).then(res => {
        if (res.code === SUCCESS_CODE) {
          // console.log('房型列表',res)
          list.initHotelList = res.pageResult.pageData.slice(
            0,
            this.hotelListNum
          );
          list.hotelList = res.pageResult.pageData.slice(0, this.hotelListNum);
          list.hotelListAll = res.pageResult.pageData;
          this.allShowList.push(hotelText);
          this.$forceUpdate();
        }
      });
    },

    //切换日历
    clickDate(value) {
      let list = this.queryList[value.index];
      let data = this.hotelFormDate;
      let id = list.hotelId;
      // data.currentPage++
      data.hotelIds = id;
      data.checkInDate = value.date;
      // console.log(list)
      getHotelNightlyRates(data).then(res => {
        if (res.code == SUCCESS_CODE) {
          list.weekPrice = res.ratePlanResults;
          this.$forceUpdate();
        }
      });
    },
    //日历day 点击
    clickNowDate(val) {
      this.selectDate[val.index] = {
        index: val.sindex,
        date: val.date.date
      };
      this.calendarNow[val.index] = val.date.date;
      // console.log(val)
      let date = val.date.date.replace(/-/g, "/");
      let id = val.date.hotelId;
      let list = this.queryList[val.index];
      this.getHome(date, id, list);
      let homeShow = this.allShowList[val.index];
      if (!homeShow) return;
      homeShow.text = "查看更多房型";
      homeShow.ico = "el-icon-arrow-down";
      homeShow.statu = false;
    },
    getHotelDetail(val) {
      setSession("HOTELINFO", val);
      setSession("HOTELFORMDATA", this.formData);
      this.$router.push({
        name: "distributor-hotel-front-hotel-details"
      });
    },
    //酒店日历
    getList() {
      let data = this.hotelFormDate;
      let day = this.$moment(data.checkInDate).format("YYYY-MM-DD");
      // console.log('rili',this.formData)
      this.queryList.map(item => {
        data.hotelIds = item.hotelId;
        getHotelNightlyRates(data).then(res => {
          if (res.code == SUCCESS_CODE) {
            item.weekPrice = res.ratePlanResults;
            this.$forceUpdate();
            this.getHome(day, item.hotelId, item);
          }
        });
      });
    },
    //显示所有房型
    allShowHotelList(index) {
      this.allShowList.statu = !this.allShowList.statu;
      let allShow = this.allShowList[index];
      let list = this.queryList;
      if (this.allShowList.statu) {
        allShow.text = "收起";
        allShow.ico = "el-icon-arrow-up";
        list[index].hotelList = list[index].hotelListAll;
      } else {
        allShow.text = "查看更多房型";
        allShow.ico = "el-icon-arrow-down";
        list[index].hotelList = list[index].initHotelList;
      }
      this.$forceUpdate();
    },
    getDate(date = "") {
      let _date = new Date(date);
      return this.$moment(_date).format("YYYY-MM-DD");
    }
  },
  watch: {
    queryList(list) {
      if (list.length == 0) return;
      this.hotelList = list;
      let _this = this;
      getHotelPrice(list);
      async function getHotelPrice(val) {
        let hotelId = [];
        let price;
        let list = val;
        list.map(item => {
          hotelId.push(item.hotelId);
        });
        let formData = {
          checkOutDate: _this.getDate(_this.formData.checkOutTime),
          checkInDate: _this.getDate(_this.formData.checkInTime),
          hotelIds: hotelId
        };
        let minPriceResults = await getHotelMinPriceByHotelId(formData);
        price = minPriceResults.minPriceResults;
        _a(price, list);
        list.map(item => {
          if (!item.cose) item.cose = "暂无";
        });
        _this.hotelList = list;
        _this.$forceUpdate();
      }
      function _a(val, list) {
        val.map(priceItem => {
          list.some(item => {
            if (priceItem.hotelId == item.hotelId) {
              item.cose = priceItem.minPrice;
              return true;
            }
          });
        });
      }
    }
  },
  components: { kalendar, HomeList },
  props: {
    queryList: {
      type: Array,
      default: []
    },
    formData: {
      type: Object,
      default: {}
    }
  }
};
</script>
<style lang="less" scoped>
.search-show-item {
  border: 1px solid #ccc;
  border-top: 0;
  .show-item-info {
    padding: 10px;
    /deep/.item-info-img {
      height: 220px;
      margin-right: 10px;
      overflow: hidden;
      transition: all 0.4s ease;
      img {
        width: 100%;
        height: 100%;
        transition: all 0.4s ease;
      }
      &:hover {
        //  box-shadow: 0 3px 5px #7a7a7a;
        img {
          transform: scale(1.1);
        }
      }
    }
    .item-info-text {
      padding: 25px;
      .city-py {
        max-width: 85%;
      }
      p {
        color: #7b7b7b;
        padding: 6px 0;
        &:nth-child(1) {
          font-size: 26px;
          color: #237dc8;
          font-weight: normal;
        }
        &:nth-child(2) {
          font-weight: normal;
        }
      }
      .item-info-ico {
        padding: 2px 10px;
        color: white;
        margin-left: 10px;
      }
    }
  }
}
.hotel-price-box {
  min-height: 200px;
  justify-content: flex-start;
  p {
    margin: 10px 0;
    font-size: 25px;
    color: #ec6942;
  }
  .el-button {
    background: #ff6600;
    border: 0;
    border-radius: 0;
  }
}
.info-ico-a {
  background: #fbac14;
}
.info-ico-b {
  background: #9f88ff;
}
.info-ico-c {
  background: #9800e0;
}
.info-ico-d {
  background: #9800e0;
}
.info-ico-e {
  background: #ec6942;
}
.info-ico-f {
  background: #ec6942;
}
.info-ico-g {
  background: #9f88ff;
}
.info-ico-h {
  background: #9f88ff;
}
.info-font-icon {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  i {
    font-size: 25px;
    padding: 3px;
    color: #237dc8;
  }
}
.home-more-btn {
  padding: 20px 0;
  color: #2f84cb;
  font-size: 14px;
  i {
    padding-left: 10px;
  }
}
.image-slot {
  width: 100%;
  height: 100%;
}
</style>
